var map = {
	"./bathroom.svg": 55091,
	"./bedroom.svg": 32811,
	"./brush.svg": 83339,
	"./coffee.svg": 35709,
	"./crown.svg": 75018,
	"./image.svg": 49864,
	"./kitchen.svg": 23591,
	"./lamp.svg": 87419,
	"./leaf.svg": 47349,
	"./living.svg": 85438,
	"./mountain.svg": 37164,
	"./ruble.svg": 39169,
	"./snowflake.svg": 18307,
	"./star.svg": 18365,
	"./star5.svg": 95882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17365;